import React from 'react';
import {useI18n} from '../../data/hooks/i18nHooks';

const I18nString = props => {
    const {localI18n, children} = props,
        i18n = useI18n(localI18n);

    return <>{i18n[children] || ''}</>;
};

export default I18nString;
